import React from 'react';
import styled from 'styled-components';
import { InputLabel, InputStyled, InputWrapper } from '@components/shared/SharedStyles';
import { P } from './Typography';

export default function Input(props: {
  heading?: string | false;
  value: string;
  onChange?: any;
  type?: string;
  placeholder?: any;
  style?: any;
  dataRecurly?: any;
  errorMessage?: string;
  onBlur?: any;
  dataCy?: string;
  mobile?: boolean;
  readOnly?: boolean;
  name?: string;
  marginBottom?: string;
  autocorrect?: string;
  autocapitalize?: string;
  autocomplete?: string;
  testId?: string;
  disabled?: boolean;
}) {
  const {
    heading,
    value,
    onChange,
    placeholder,
    style,
    dataRecurly,
    type = 'text',
    errorMessage,
    onBlur,
    dataCy = '',
    mobile,
    readOnly,
    name = 'unnamed',
    marginBottom,
    autocorrect,
    autocapitalize,
    autocomplete,
    testId = '',
    disabled = false
  } = props;
  return (
    <InputWrapper style={style}>
      {heading && <InputLabel>{heading}</InputLabel>}
      <InputStyled
        data-cy={dataCy}
        defaultValue={value}
        onChange={onChange}
        placeholder={placeholder}
        data-recurly={dataRecurly}
        type={type}
        $error={errorMessage}
        onBlur={onBlur}
        $mobile={mobile}
        readOnly={!!readOnly}
        name={name}
        autoCorrect={autocorrect}
        autoCapitalize={autocapitalize}
        autoComplete={autocomplete}
        $marginBottom={marginBottom}
        data-testid={testId}
        disabled={disabled}
      />
      {errorMessage && (
        <ErrorWrapper>
          <P data-cy="error" $mods={['error']} style={{ marginTop: 0, marginBottom: 12 }}>
            {errorMessage}
          </P>
        </ErrorWrapper>
      )}
    </InputWrapper>
  );
}

const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: -11px;
`;
